<template>
  <div class="site">
    <header class="top">
      <a class="brand" href="javascript:;" @click="goSite">
        <img src="/brand-logo.png" alt="华锐智企云 ERP" />
        <span>华锐智企云 ERP</span>
      </a>
      <div class="top-actions">
        <button class="login-btn" type="button" @click="goLogin">登录注册</button>
        <button class="consult-btn on" type="button">联系咨询</button>
      </div>
    </header>

    <main class="main">
      <p class="eyebrow">联系咨询</p>
      <h1>需要了解华锐智企云 ERP，可以直接联系我们</h1>
      <div class="cards">
        <section class="card">
          <h2>咨询电话</h2>
          <a class="value" href="tel:18796878316">18796878316</a>
        </section>
        <section class="card">
          <h2>咨询邮箱</h2>
          <a class="value" href="mailto:service@harence.com">service@harence.com</a>
        </section>
        <section class="card qr-card">
          <h2>微信二维码</h2>
          <img src="/site/wechat-qr.png" alt="微信咨询二维码" />
          <p>微信扫码咨询</p>
        </section>
      </div>
    </main>

    <p class="legal">© 2026 苏州华锐信息科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备19066823号-1</a></p>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  mounted() {
    document.title = '联系咨询 - 华锐智企云 ERP'
  },
  methods: {
    goSite() {
      this.$router.push('/site')
    },
    goLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.site {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(900px 420px at 8% -10%, rgba(37, 99, 235, 0.14), transparent 60%),
    #f6f8fb;
  color: #0f172a;
}
.top {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  height: 68px;
  padding: 0 40px;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
  backdrop-filter: blur(12px);
}
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
}
.brand img {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  object-fit: contain;
  background: #fff;
}
.top-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}
.login-btn,
.consult-btn {
  height: 38px;
  padding: 0 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.login-btn {
  border: none;
  background: #1d4ed8;
  color: #fff;
}
.login-btn:hover { background: #1e40af; }
.consult-btn {
  border: 1px solid #1d4ed8;
  background: #fff;
  color: #1d4ed8;
}
.consult-btn.on {
  background: #1d4ed8;
  color: #fff;
  cursor: default;
}
.main {
  flex: 1;
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
  padding: 56px 40px 24px;
  box-sizing: border-box;
}
.eyebrow {
  margin: 0 0 12px;
  color: #1d4ed8;
  font-size: 16px;
  font-weight: 700;
}
h1 {
  margin: 0 0 28px;
  font-size: 32px;
  line-height: 1.35;
}
.cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.card {
  padding: 24px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e7eef6;
}
.card h2 {
  margin: 0 0 10px;
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
}
.value {
  color: #0f172a;
  font-size: 22px;
  font-weight: 700;
  text-decoration: none;
}
.value:hover { color: #1d4ed8; }
.qr-card {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.qr-card img {
  width: 220px;
  height: 220px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
}
.qr-card p {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 13px;
}
.legal {
  margin: 0;
  padding: 18px 24px 28px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
.legal a { color: #64748b; text-decoration: none; }
.legal a:hover { color: #1d4ed8; }
@media (max-width: 720px) {
  .top { padding: 0 16px; }
  .top-actions {
    position: fixed;
    top: 14px;
    right: 12px;
    z-index: 30;
    gap: 8px;
  }
  .login-btn,
  .consult-btn {
    height: 34px;
    padding: 0 12px;
    font-size: 13px;
  }
  .main { padding: 36px 16px 16px; }
  h1 { font-size: 26px; }
  .cards { grid-template-columns: 1fr; }
  .qr-card { grid-column: auto; }
}
</style>
